// Nome exibido da linha: o principal so com o nome do cliente, proxy regional com o nome do proxy junto
export default function rotuloAlvo(linha) {
	return linha?.proxy ? `${linha?.nome} · ${linha.proxy}` : linha?.nome;
}
